module.exports = __webpack_public_path__ + "img/follow_up.ca976f16.svg";